import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58d94e05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gridEncontrar" }
const _hoisted_2 = { class: "form-floating mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "buscar" }, "Médico:", -1))
const _hoisted_4 = { class: "gridposts" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("select", {
          id: "search",
          type: "buscar",
          placeholder: "Buscar",
          class: "form-select",
          autofocus: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.term) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => ($props.search($data.term)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.medicos, (medico, index) => {
            return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(medico.emisor), 1))
          }), 128))
        ], 544), [
          [_vModelSelect, $data.term]
        ]),
        _hoisted_3
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.toggleFilter())),
        class: "btn btn-primary btn-sm mb-2"
      }, " Filtrar por Motivo "),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.filters, (filter) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "post",
            style: {"cursor":"pointer"},
            key: filter,
            onClick: () => $props.filterDocumentos(filter)
          }, _toDisplayString(filter), 9, _hoisted_5))
        }), 128))
      ], 512), [
        [_vShow, $data.a]
      ])
    ])
  ]))
}